import LottieLoaders from "../../../components/UI/LottieLoaders";

const LoadingDesignFiles = ({ files, isFigma }) =>
  files.length > 0 ? (
    <LottieLoaders pageCount={files.length} isFigma={isFigma} />
  ) : (
    <LottieLoaders loader isFigma={isFigma} />
  );

export default LoadingDesignFiles;
